import classNames from 'classnames';
import React, { ForwardedRef, useState } from 'react';
import FormInput from './FormInput';
import { FieldError } from 'react-hook-form';
import PasswordStrengthBar from 'react-password-strength-bar';
import { Eye, EyeSlash } from '@phosphor-icons/react';

interface Props extends React.SelectHTMLAttributes<HTMLInputElement> {
  className?: string;
  newPassword: boolean;
  error?: FieldError | string;
  onChangeScore?: (score: number) => void;
}

/**
 * Password element with the option to show or hide the password
 *
 * We can use this <Password/> component inside the Forms-Hooks as it is 100% compatible with the hooks
 */
const Password = React.forwardRef(function Password(
  { newPassword, className, onChangeScore, onChange, ...rest }: Props,
  ref: ForwardedRef<HTMLInputElement>,
): JSX.Element {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [password, setPassword] = useState<string>();

  return (
    <>
      <FormInput
        autoComplete={newPassword ? 'new-password' : 'current-password'}
        onChange={e => {
          setPassword(e.currentTarget.value);
          onChange?.(e);
        }}
        {...rest}
        ref={ref}
        type={showPassword ? 'text' : 'password'}
        className={classNames(className)}
        postNode={
          <button type='button' onClick={() => setShowPassword(prevState => !prevState)} tabIndex={-1}>
            {!showPassword && <Eye className='text-gray-500' />}
            {showPassword && <EyeSlash className='text-gray-500' />}
          </button>
        }
      />
      {onChangeScore && (
        <PasswordStrengthBar scoreWordClassName='hidden' minLength={0} password={password} onChangeScore={score => onChangeScore(score)} />
      )}
    </>
  );
});

export default Password;
